Hop.defineModule('mobile-banner', (root) => {
    const bannerHeight = root.offsetHeight;
    const BANNER_SHOWN_CLASS = 'MOBILE_BANNER_SHOWN';
    const closeBtn = root.querySelector('#mobile-banner__close-btn');

    function isMobile() {
        return window.matchMedia('(max-width:767px)').matches;
    }

    function addDisplayMobileBannerClass() {
        document.body.classList.add(BANNER_SHOWN_CLASS);
        root.classList.add('active');
    }

    function displayMobileBanner() {
        return localStorage.mobileBanner !== 'seen' && isMobile();
    }

    function closeBanner(e) {
        localStorage.setItem('mobileBanner', 'seen');
        removeMobileBannerDisplayClass();
        removeEventListener(e);
        displayMobileBannerIfNeeded();
    }

    function removeMobileBannerDisplayClass() {
        document.body.classList.remove(BANNER_SHOWN_CLASS);
        root.classList.remove('active');
    }

    function toggleMobileBanner() {
        let windowScrollTop;

        // While vue app is loading, we can't calculate scrollTop() property as we're on load screen
        setTimeout(() => {
            windowScrollTop = window.scrollY;
            if (windowScrollTop <= bannerHeight) {
                addDisplayMobileBannerClass();
            } else {
                removeMobileBannerDisplayClass();
            }
        });
    }

    function displayMobileBannerIfNeeded() {
        if (displayMobileBanner()) {
            toggleMobileBanner();
            window.addEventListener('scroll', toggleMobileBanner);
            closeBtn.addEventListener('click', closeBanner);
        }
    }

    displayMobileBannerIfNeeded();

    function removeEventListener() {
        window.removeEventListener('scroll', toggleMobileBanner);
        closeBtn.removeEventListener('click', closeBanner);
    }

    return function destroy() {
        if (displayMobileBanner()) {
            removeEventListener();
        }
    };
});
